import React, { useEffect, useState } from "react";

const TypingText = ({ words = [], className = "" }) => {
  const [index, setIndex] = useState(0);
  const [sub, setSub] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = words[index % words.length] || "";
    let timeout;
    if (!deleting && sub === current) {
      timeout = setTimeout(() => setDeleting(true), 1600);
    } else if (deleting && sub === "") {
      setDeleting(false);
      setIndex((i) => (i + 1) % words.length);
    } else {
      timeout = setTimeout(() => {
        setSub((s) => {
          if (deleting) return current.slice(0, s.length - 1);
          return current.slice(0, s.length + 1);
        });
      }, deleting ? 45 : 85);
    }
    return () => clearTimeout(timeout);
  }, [sub, deleting, index, words]);

  return (
    <span className={`typed-caret ${className}`}>{sub}</span>
  );
};

export default TypingText;
